import getter from './../common/getter';

export function getWizardDataFromDataRows(dataRows) {
    var result = [];

    dataRows.forEach(function (item) {
        var dataItem = item.dataItem;
        var dataColumns = item.dataColumns;

        var row = [];
        dataColumns.forEach(function (column) {
            row.push({
                field: column.title || column.field,
                value: getter(column.field)(dataItem)
            });
        });

        result.push(row);
    });

    return result;
}
